// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","subscribeFeaturesTableContainer":"_2jSQF6467_VQ0cldmCKNIP"};